import React, { useEffect } from "react";

const VideoMedia = ({ url }) => {
  useEffect(() => {
    let video = document.getElementById("video-media");
    video.load();
  }, [url]);

  return (
    <video key={url} id="video-media">
      <source src={`${url}#t=5`}></source>
    </video>
  );
};

export default VideoMedia;
